var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: 0
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: 2
  }, /*#__PURE__*/React.createElement("stop", {
    id: "E",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "F",
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 3
  }, /*#__PURE__*/React.createElement("stop", {
    id: "G",
    stopColor: "#2e3436"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "H",
    offset: 1,
    stopColor: "#2e3436",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 4
  }, /*#__PURE__*/React.createElement("stop", {
    id: "I",
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    id: "J",
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y1: 10.03,
    x2: 0,
    y2: 37.969,
    id: 5,
    xlinkHref: "#4",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 25.391,
    cy: 42.806,
    r: 22.753,
    id: 6,
    xlinkHref: "#3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,0.1123188,0,37.998412)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2.531,
    y1: -16.178,
    x2: 15.851,
    y2: 27.16,
    id: 7,
    xlinkHref: "#2",
    gradientUnits: "userSpaceOnUse"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 48.144085,42.806374 a 22.753027,2.5555935 0 1 1 -45.506054,0 22.753027,2.5555935 0 1 1 45.506054,0 z",
    transform: "matrix(1.0834897,0,0,0.5317875,-3.5109498,16.012073)",
    id: 8,
    opacity: 0.8,
    fill: "url(#6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 30,
    x: 1.5,
    y: 9,
    id: 9,
    fill: "#d3d7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 15,
    x: 1.5,
    y: 24,
    id: "A",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2.03125,9.53125 0,28.9375 43.9375,0 0,-28.9375 -43.9375,0 z",
    id: "B",
    opacity: 0.6,
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3.03125,10.53125 0,26.9375 41.9375,0 0,-26.9375 -41.9375,0 z",
    id: "C",
    opacity: 0.8,
    fill: "none",
    stroke: "url(#5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2.53125,10.03125 0,14.65625 c 11.943413,-3.638693 26.281715,-6.287584 42.9375,-8.375 l 0,-6.28125 -42.9375,0 z",
    id: "D",
    opacity: 0.6,
    fill: "url(#7)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlFlag);
export default __webpack_public_path__ + "static/media/plFlag.d19dbc7045e2ce220e43f2ba210df62c.svg";
export { ForwardRef as ReactComponent };